@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.map.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.PluralStringResource
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/fr.frux.feature.map.resources/"

@delegate:ResourceContentHash(-1_503_555_754)
internal val Res.plurals.map_site_species_more: PluralStringResource by lazy {
      PluralStringResource("plurals:map_site_species_more", "map_site_species_more", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 109),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainPlurals0Resources(map: MutableMap<String, PluralStringResource>) {
  map.put("map_site_species_more", Res.plurals.map_site_species_more)
}
